module.exports = __webpack_public_path__ + "media/svg/arrow-left-b7a30173.svg";